<script lang="typescript">

  import { onMount, createEventDispatcher } from 'svelte';

  export let roomName:string;
  export let jwt:string;
  export let options:any;

  const dispatch = createEventDispatcher();

  let api: JitsiMeetExternalAPI | null = null;
  let width: number;
  $: height = Math.round(width * 0.75);
  let joined = false;

  const startVideoMeeting = () => {
    const domain = "8x8.vc";
    const parentNode = document.querySelector("#jitsi-video-meeting");
    const jitsiOptions = {
      jwt: jwt,
      roomName: roomName,
      parentNode: parentNode,
      width: "100%",
      //height: "100%",
    };
    console.log({ jitsiOptions });
    api = new JitsiMeetExternalAPI(domain, {...jitsiOptions, ...options});
    api.addListener("videoConferenceJoined", participantJoined);
    api.addListener("videoConferenceLeft", participantLeft);
  };

  const participantJoined = () => {
    console.log("JITSI JOINING..." + new Date());
    joined = true;
    dispatch('join');
  };

  const participantLeft = () => {
    if (joined) {
      dispatch('leave');
      joined = false;
    }
  };

  const dispose = () => {
    console.log("JITSI DISPOSE...");
    if (api) {
      if (joined) {
        api.executeCommand('hangup');
      }
      api.removeListener('videoConferenceJoined', participantJoined);
      api.removeListener('videoConferenceLeft', participantLeft);
      api.dispose();
    }
  };

  onMount(() => {
    startVideoMeeting();
    return dispose;
  });
</script>

<div bind:clientWidth={width} style="height: {height}px;" id="jitsi-video-meeting">
</div>

<style>
  #jitsi-video-meeting {
    /*
    border: 1px solid #eee;
    */
    text-align: center;
    vertical-align: middle;
  }
</style>
